import { render, staticRenderFns } from "./ProofOfIncome.vue?vue&type=template&id=7161230c&scoped=true&"
import script from "./ProofOfIncome.vue?vue&type=script&lang=js&"
export * from "./ProofOfIncome.vue?vue&type=script&lang=js&"
import style0 from "./ProofOfIncome.vue?vue&type=style&index=0&id=7161230c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7161230c",
  null
  
)

export default component.exports